 <app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="docPrix?.value" 
[label]="step11.getvalue"
[type]="'number'" [rule]="''"
[name]="getUid()+'_SepAtt_value'">
</app-form-input>


<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="docPrix?.devise" 
[label]="step11.getdevise"
[type]="'autocomplete'" 
[autoCompleteType]="'DEVISE'"
[autoCompleteTypeIndex]="0"
[rule]="'pattern_13'"
[errorMessage]="{}"
[name]="getUid()+'_SepAtt_devise'">
</app-form-input>
